import { Flex, Skeleton } from '@chakra-ui/react';

import { InputV2 } from 'uiToolkitV1/InputV2';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { EngagementAnswerOptions } from '../slice/AddEngagementQuestion.slice';

type ScaleQuestionProps = {
  answerOptions?: EngagementAnswerOptions; // Array of descriptions for each scale value
  onDescriptionChange: (index: number, value: string) => void; // Callback for description changes
};

const ScaleBasedScore = ({ answerOptions = [], onDescriptionChange }: ScaleQuestionProps) => (
  <Flex flexDirection="column" gap="16px">
    {/* Scale Row */}
    <Flex flexDirection="column" gap="8px" w="100%">
      {answerOptions.map(({ description, score, isDisabled = false }, i) => (
        <Flex key={score} alignItems="center" gap="16px" w="100%">
          {/* Scale Number */}
          <TextBodyMedium textAlign="center" fontWeight="bold" minWidth="40px">
            {score}
          </TextBodyMedium>
          {isDisabled ? (
            <Skeleton bg="#EAEAEA" height="12px" width="30%" animation={false} borderRadius="8px" />
          ) : (
            <InputV2
              isDashed
              placeholder="Enter label"
              value={description ?? ''}
              onChange={(e) => onDescriptionChange(i, e.target.value)}
              style={{ width: '100%' }}
              isDisabled={isDisabled}
            />
          )}
        </Flex>
      ))}
    </Flex>
  </Flex>
);

export { ScaleBasedScore };
